import { MutationTree } from 'vuex'
import { SettingsState } from './types'
import { Settings } from '../interfaces/Settings'

export const mutations: MutationTree<SettingsState> = {
  addSettings(state, settings: Settings) {
    state.appSettings = settings.frontEndSettings
    state.environment = settings.environment
    if (settings.languageSettings) {
      state.languageSettings = JSON.parse(settings.languageSettings)
    }
    if (settings.themeSettings) {
      state.themeSettings = JSON.parse(settings.themeSettings)
    }

  },
}
